import formatTime from "helpers/formatTime";
import { MDBContainer, MDBTable, MDBTableBody, MDBTableHead } from "mdbreact";
import numeral from "numeral";
import React, { useEffect, useState } from "react";
import sortIcon from "assets/images/icons/sort_icon.svg";
import Tabel from "./tabel";
import { useDispatch, useSelector } from "react-redux";


// Define constant for columns
const COLUMNS = [
  { label: "Brand Name", dataField: "name", dataType: "string" },
  { label: "", dataField: "favorite", dataType: "boolean" },
  { label: "Creation Date", dataField: "createdAt", dataType: "date" },
  { label: "Owner", dataField: "user.name", dataType: "string" },
  { label: "Post", dataField: "posts.length", dataType: "number" },
  { label: "Members", dataField: "users", dataType: "number" },
  { label: "Action", dataField: "action", dataType: "string" },
];

const BrandListView = ({ brands, milestones, users: usersObj, setModal, setBrandToDelete, setBrandToUpdate, setBrandListToEdit, isAdmin, brandNumber, sortedToNewer }) => {
  const [sortBy, setSortBy] = useState('name');
  const [sortDirection, setSortDirection] = useState("desc");

  const handleSort = (column) => {
    if (sortBy === column.dataField) {
      // Toggle sorting direction
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column.dataField);
      setSortDirection("desc");
    }
  };


  const sortedBrands = [...brands].sort((a, b) => {
    if (sortBy) {
      const aValue = a[sortBy];
      const bValue = b[sortBy];

      if (COLUMNS.find((column) => column.dataField === sortBy)?.dataType === "string") {
        return sortDirection === "asc" ? aValue?.localeCompare(bValue) : bValue?.localeCompare(aValue);
      } else if (COLUMNS.find((column) => column.dataField === sortBy)?.dataType === "date") {
        const dateA = new Date(aValue);
        const dateB = new Date(bValue);
        return sortDirection === "asc" ? dateA - dateB : dateB - dateA;
      } else if (COLUMNS.find((column) => column.dataField === sortBy)?.dataType === "number") {
        return sortDirection === "asc" ? aValue - bValue : bValue - aValue;
      }
    }

    return 0;
  });

  useEffect(() => {
   handleSort({ label: "3D Date", dataField: "date", dataType: "date" })
  },[sortedToNewer])

  return (
    <div className="px-3 py-1 karban-container">
      <MDBContainer fluid>
        <div className="brand-table-div position-relative w-100 mt-4 bid-table-border">
        <MDBTable small className="brand-list-view-table">
          <MDBTableHead color="" textWhite>
            <tr>
              {COLUMNS.map((column, index) => (
                <th key={index} onClick={() => handleSort(column)}>
                  {column.label}
                  {sortBy === column.dataField && (
                    <img
                      src={sortIcon}
                      alt="Sort Icon"
                      style={{ marginLeft: '10px',transform: sortDirection === "asc" ? "rotate(180deg)" : "rotate(0deg)" }}
                    />
                  )}
                </th>
              ))}
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {sortedBrands.map((brandItem, i) => <Tabel isAdmin={isAdmin} key={i} brandItem={brandItem} milestones={milestones} usersObj={usersObj} setModal={setModal} setBrandToDelete={setBrandToDelete} setBrandToUpdate={setBrandToUpdate} setBrandListToEdit={setBrandListToEdit}/>)}
          </MDBTableBody>
        </MDBTable>
        </div>
      </MDBContainer>
    </div>
  );
};

export default BrandListView;
